import type { RiskQuote } from '../lib/types';
import styles from './RiskQuotes.module.css';

const categoryLabels: Record<RiskQuote['category'], string> = {
  guidance: 'Guidance',
  demand: 'Demand',
  cost: 'Cost',
  competitive: 'Competitive',
  macro: 'Macro',
  litigation: 'Litigation',
};

export function RiskQuotes({ quotes, className }: { quotes: RiskQuote[]; className?: string }) {
  return (
    <ul className={[styles.list, className].filter(Boolean).join(' ')}>
      {quotes.map((q, i) => (
        <li key={i} className={styles.item}>
          <span className={styles.tag}>{categoryLabels[q.category] ?? q.category}</span>
          <blockquote className={styles.quote}>“{q.quote}”</blockquote>
          <span className={[styles.ref, 'mono'].join(' ')}>{q.ref}</span>
        </li>
      ))}
    </ul>
  );
}
